export default "__VITE_ASSET__f$GGeqK___"